import { ConfigMurucaResourceLayout } from '@net7/boilerplate-muruca';

export default {
  maxHeight: 100, // Threshold where the "read-more" button appears
  title: 'resource#title_graffito',
  type: 'graffito',
  tabs: 'graffito',
  sections: {
    top: [
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
      {
        id: 'editor_metadata',
        type: 'metadata',
      },
      {
        id: 'image-viewer-iiif',
        type: 'viewer-iiif',
        title: 'resource#image-viewer-iiif',
        options: {
          libOptions: {
            window: {
              sideBarOpenByDefault: false,
              allowClose: false,
              allowMaximize: true,
              defaultSideBarPanel: 'info',
              views: [
                { key: 'single' },
                { key: 'gallery' },
              ],
              workspaceControlPanel: {
                enabled: false,
              },
            },
            id: 'mirador-container',
          },
        }
      },
      {
        id: 'text-viewer-graffito_text',
        type: 'text-viewer',
        options: {
          searchId: 'xml_text',
        },
      },
      {
        id: 'tab-bar',
        type: 'tabs',
      },
    ],
    content: [
      {
        id: 'collection-graffito_links_interni',
        type: 'collection',
        title: 'resource#collection_graffito_links_interni',
        grid: 1
      },
      {
        id: 'collection-graffito_links_esterni',
        type: 'collection',
        title: 'resource#collection_graffito_links_esterni',
        grid: 1
      },
      {
        id: 'collection-graffito_links_termini',
        type: 'collection',
        title: 'resource#collection_graffito_links_termini',
        grid: 1
      }
    ],
  },
} as ConfigMurucaResourceLayout;